import React, { useEffect, useRef } from 'react'

const PencilIcon = () => (
  <svg className="h-3.5 w-3.5 shrink-0 text-white/80" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
    />
  </svg>
)

type EditableManageFieldProps = {
  fieldId: string
  isManaging: boolean
  activeField: string | null
  onEdit: (fieldId: string) => void
  onDeactivate: () => void
  className?: string
  children: React.ReactNode
  renderEditor: () => React.ReactNode
}

export const EditableManageField: React.FC<EditableManageFieldProps> = ({
  fieldId,
  isManaging,
  activeField,
  onEdit,
  onDeactivate,
  className = '',
  children,
  renderEditor,
}) => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!isManaging || activeField !== fieldId) return

    const handlePointerDown = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        onDeactivate()
      }
    }

    document.addEventListener('mousedown', handlePointerDown)
    return () => document.removeEventListener('mousedown', handlePointerDown)
  }, [activeField, fieldId, isManaging, onDeactivate])

  if (isManaging && activeField === fieldId) {
    return (
      <div ref={containerRef} className={className}>
        {renderEditor()}
      </div>
    )
  }

  return (
    <div ref={containerRef} className={className}>
      <span className="inline-flex max-w-full items-center gap-1.5">
        {children}
        {isManaging && (
          <button
            type="button"
            onClick={() => onEdit(fieldId)}
            className="inline-flex shrink-0 rounded p-0.5 hover:bg-white/10"
            aria-label="Edit field"
          >
            <PencilIcon />
          </button>
        )}
      </span>
    </div>
  )
}

export const heroInputClass =
  'w-full rounded-lg border border-white/40 bg-white/15 px-3 py-1.5 text-base text-white placeholder-white/50 focus:border-white focus:outline-none'
